import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { DocumentServiceGateway } from 'src/app/application/gateway/DocumentServiceGateway';
import { QualityControlReviewGateway } from 'src/app/application/gateway/QualityControlReviewGateway';
import { QualityControlReview, UploadQualityControlReviewPdfRequest } from 'src/app/domain/models/QualityControlReview';
import { Routes } from 'src/app/infrastructure/routes';
import { BasicUser } from 'src/app/domain/models/User';

@Component({
  selector: 'app-qc-user-review-documents',
  templateUrl: './qc-user-review-documents.component.html',
  styleUrls: ['./qc-user-review-documents.component.css'],

})
export class QcUserReviewDocumentsComponent implements OnInit {

  breadcrumbItems: MenuItem[] = []
  breadcrumbHomeItem: MenuItem = {}

  reviewId: string | undefined
  review: QualityControlReview | undefined

  loading: boolean = false
  documents: any

  profileUser: BasicUser | undefined


  constructor(private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _messageService: MessageService,
    public translate: TranslateService,
    private _qualityControlReviewService: QualityControlReviewGateway,
    private _authService: AuthGateway,
    private _documentService: DocumentServiceGateway,) {

    this._activatedRoute.params.subscribe(params => {
      this.reviewId = params['reviewId']
    })
  }

  ngOnInit(): void {

    this.profileUser = this._authService.getUser()

    let breadcrumbMenuItemLabel1 = "Origin QC Review documents"
    let breadcrumbHomeMenuItemLabel = 'Origin QC Review'

    if(this.profileUser) {
      switch(this.profileUser.lang) {
        case 'en':
          breadcrumbMenuItemLabel1 = "Origin QC Review documents"
          breadcrumbHomeMenuItemLabel = 'Origin QC Review'
          break
        case 'es':
          breadcrumbMenuItemLabel1 = 'Documentos Revisión QC Origen'
          breadcrumbHomeMenuItemLabel = 'Revisión QC Origen'
          break
      }
    }

    this.breadcrumbItems = [{ label: breadcrumbMenuItemLabel1, disabled: true}]
    //this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, routerLink: '/' + Routes.userLoadOrdersProgram };
    this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, command:  () => this.goToReviews()};


    this.loadReview()
  }

  loadReview() {
    this.loading = true
    if(this.reviewId) {
      this._qualityControlReviewService.getByIdFreshFruit(this.reviewId).subscribe({
        next: (v) => {
          console.log(v)
          this.review = v
          this.loading = false
        },
        error: (e) => {
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: 'Could not retrieve the import order detail' });

          this.loading = false
          console.log(e)
        },
        complete: () =>  {
          this.loading = false
          console.info('Import order detail query successfully')
        }
      })
    }
  }

  onSelectReviewDocumentPdf(event: any) {
    if(this.review) {
      let request: UploadQualityControlReviewPdfRequest = {
        qualityControlReviewGuid: this.review.guid,
        pdf: event.files[0]
      }

      this._qualityControlReviewService.uploadOriginQCReviewPdf(request).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: 'Review pdf file saved successfully.' })
        },
        error: (e) => {
          console.log(e)
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: 'Can not save pdf file.' })
        },
        complete: () =>  {
          this.loading = false
          console.info('QCReviewPdf uploaded successfully')
        }
      })
    }
  }

  onSelectConsolidationDocumentPdf(event: any) {
    if(this.review) {
      let request: UploadQualityControlReviewPdfRequest = {
        qualityControlReviewGuid: this.review.guid,
        pdf: event.files[0]
      }

      this._qualityControlReviewService.uploadOriginQCConsolidationPdf(request).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: 'Consolidation pdf file saved successfully.' })
        },
        error: (e) => {
          console.log(e)
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: 'Can not save pdf file.' })
        },
        complete: () =>  {
          this.loading = false
          console.info('QCReviewPdf uploaded successfully')
        }
      })
    }
  }

  viewOriginQCReviewDocument() {
    if(this.review) {
      this._documentService.getOriginQCReviewDocument(this.review.guid).subscribe((resultBlob: any) => {
        const downloadURL = window.URL.createObjectURL(resultBlob.body);
        window.open(downloadURL);})
    }
  }

  viewOriginQCConsolidationDocument() {
    if(this.review) {
      this._documentService.getOriginQCConsolidationDocument(this.review.guid).subscribe((resultBlob: any) => {
        const downloadURL = window.URL.createObjectURL(resultBlob.body);
        window.open(downloadURL);})
    }
  }

  goToReviews() {
    if(this.review && !this.review.qualityControlDate)
      this._router.navigate(['/' + Routes.qcUserReviews])

    if(this.review && this.review.qualityControlDate)
      this._router.navigate(['/' + Routes.qcUserOriginReviewed])
  }
}
